//export const ApiUrl = "http://localhost:10000";
export const ApiUrl = "https://partnerapi.techsystem.world";
